import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { travelerAppConfigToken } from '../config/tokens';
import { TravelerAppConfig } from '../config/traveler-app-config.model';
import { CustomerDisplayData } from '../models/route';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerDisplayService {
  private _httpClient = inject(HttpClient);
  private _appConfig = inject<TravelerAppConfig>(travelerAppConfigToken);

  getCustomerDisplayData(code: string): Observable<CustomerDisplayData> {
    const url = `${this._appConfig.customerDisplayApiUrl}/api/v1/customerdisplay/${code}`;
    return this._httpClient.get<CustomerDisplayData>(url);
  }
}
